// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

import React from 'react'
import { connect } from 'react-redux'
import { Modal, Typography } from 'antd'
import { formatDateRange } from '../../utils/time'
import { Delete } from '../icon'
import moment from 'moment'

class PreDownloadList extends React.Component {
  handlePreTaskDelete (index) {
    const { removePreTask } = this.props

    Modal.confirm({
      title: 'Do you want to delete the task?',
      content: '',
      onOk: () => removePreTask(index)
    })
  }

  render () {
    const { preTaskList } = this.props
    // const fixHeight = !!editingPreTask && editingPreTask.isAddButtonShow
    return (
      <div className='pre-download-task-container'>
        <Typography.Text type='secondary'>Job</Typography.Text>
        <div
          // style={fixHeight ? { maxHeight: 'calc(100vh - 696px)' } : { maxHeight: 'calc(100vh - 720px)' }}
          className='pre-download-task-list'
        >
          {!preTaskList.length ? (
            <div>N/A</div>
          ) : (
            preTaskList.map((task, index) => {
              return (
                <div key={index} className='pre-download-task-item'>
                  <div>
                    <div className='task-name'>
                      <span style={{ textTransform: 'uppercase' }}>{task.jobName}</span>
                    </div>
                    <div className='task-time'>
                      {moment(task.startTime).format('hh:mm A')} ~ {moment(task.endTime).format('hh:mm A')},
                      {formatDateRange(task.startDate, task.endDate)}
                    </div>
                  </div>
                  <div onClick={() => this.handlePreTaskDelete(index)} className='delete-button'>
                    <Delete />
                  </div>
                </div>
              )
            })
          )}
        </div>
      </div>
    )
  }
}

const mapState2Props = ({ download, loading }) => ({
  ...download,
  loading: loading.models.download
})
const mapDispatch2Props = ({ download }) => ({ ...download })

export default connect(mapState2Props, mapDispatch2Props)(PreDownloadList)
